//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Paginate from '../mixins/paginate';
import PageLimiter from '../PageLimiter.vue';
import ProductTile from '../ProductTile.vue';
import Pagination from '../Pagination.vue';

export default {
	name: 'PageSearch',

	components: { PageLimiter: PageLimiter, ProductTile: ProductTile, Pagination: Pagination },
	mixins: [Paginate],

	props: {
		page: {
			type: Object,
			default: function _default() {
				return {};
			}
		},

		crumbs: {
			type: Array,
			default: function _default() {
				return [];
			}
		}
	},

	computed: {
		count: function count() {
			return this.itemsData.count + ' ' + this.$lang('product', this.itemsData.count, this.$store.state.settings.lang);
		},
		countTitle: function countTitle() {
			return this.$lang('searchCountTitle', this.itemsData.count, this.$store.state.settings.lang).replace('{{count}}', this.count);
		},
		emptyTitle: function emptyTitle() {
			return this.$lang('searchEmptyTitle', this.itemsData.count, this.$store.state.settings.lang);
		},
		req: function req() {
			return this.$route.query.req;
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/pages/PageSearch.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/pages/PageSearch.vue
// module chunks = 0